import React from 'react';
import { useFavorites } from '../contexts/FavoritesContext';
import { useAuth } from '../context/AuthContext';

interface FavoriteButtonProps {
  bookId: number;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ 
  bookId, 
  size = 'medium', 
  className = '' 
}) => {
  const { isFavorite, toggleFavorite, loading } = useFavorites();
  const { user } = useAuth();

  const handleToggleFavorite = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!user) {
      alert('Trebuie să vă autentificați pentru a adăuga cărți la favorite.');
      return;
    }

    await toggleFavorite(bookId);
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'w-6 h-6 p-1';
      case 'large':
        return 'w-12 h-12 p-2';
      default:
        return 'w-8 h-8 p-1.5';
    }
  };

  const getIconSize = () => {
    switch (size) {
      case 'small':
        return 'w-4 h-4';
      case 'large':
        return 'w-8 h-8';
      default:
        return 'w-5 h-5';
    }
  };

  const isBookFavorite = isFavorite(bookId);

  return (
    <button
      onClick={handleToggleFavorite}
      disabled={loading}
      className={`
        ${getSizeClasses()}
        ${isBookFavorite 
          ? 'bg-red-500 hover:bg-red-600 text-white' 
          : 'bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-red-500'
        }
        rounded-full transition-colors duration-200 
        flex items-center justify-center
        ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
      title={isBookFavorite ? 'Elimină din favorite' : 'Adaugă la favorite'}
    >
      {loading ? (
        <div className={`${getIconSize()} animate-spin`}>
          <svg
            className="w-full h-full"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </div>
      ) : (
        <svg
          className={getIconSize()}
          fill={isBookFavorite ? 'currentColor' : 'none'}
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      )}
    </button>
  );
};

export default FavoriteButton; 
